export default __webpack_public_path__ + "static/media/CourseNameExl.ccc52d80.xlsx";